import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import {
  ButtonBack,
  ButtonNext,
  CarouselProvider,
  Slide,
  Slider,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import Image from '@plone/volto/components/theme/Image/Image';
import { homepageImageSources } from '../../../helpers/homepageUtils';

const ROLLOVER_WIDTH = 270;
const ROLLOVER_HEIGHT = 170;

const HomepageRolloverBody = ({ items = [], editPreview = false }) => {
  const [visibleSlides, setVisibleSlides] = useState(1);

  const updateVisibleSlides = useCallback(() => {
    if (typeof window === 'undefined') return;
    let count = Math.trunc(window.innerWidth / ROLLOVER_WIDTH) || 1;
    if (count > items.length) {
      count = items.length;
    }
    setVisibleSlides(count);
  }, [items.length]);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    window.addEventListener('resize', updateVisibleSlides, false);
    updateVisibleSlides();
    return () =>
      window.removeEventListener('resize', updateVisibleSlides, false);
  }, [updateVisibleSlides]);

  if (!items.length) return null;

  const slideContent = (item, index) => {
    const sources = homepageImageSources(item.image, {
      minWidth: 260,
      fallback: 'preview',
    });

    return (
      <div className={`rollover-item${index === 0 ? ' first' : ''}`}>
        {sources.src ? (
          <Image
            className="rollover-item-image"
            src={sources.src}
            srcSet={sources.srcSet}
            sizes="260px"
            alt=""
            width={260}
            height={170}
            loading="lazy"
          />
        ) : null}
        <div className="rollover-item-text">{item.title}</div>
      </div>
    );
  };

  return (
    <div className="rollover-items-container">
      <CarouselProvider
        naturalSlideWidth={ROLLOVER_WIDTH}
        naturalSlideHeight={ROLLOVER_HEIGHT}
        totalSlides={items.length}
        visibleSlides={visibleSlides}
      >
        <Slider style={{ width: `${visibleSlides * ROLLOVER_WIDTH}px` }}>
          {items.map((item, index) => (
            <Slide key={item['@id'] || index} index={index}>
              {editPreview || !item.link ? (
                slideContent(item, index)
              ) : (
                <Link to={item.link}>{slideContent(item, index)}</Link>
              )}
            </Slide>
          ))}
        </Slider>

        {items.length >= visibleSlides && (
          <>
            <ButtonBack className="ui icon button">
              <Icon name="chevron left" />
            </ButtonBack>
            <ButtonNext className="ui icon button">
              <Icon name="chevron right" />
            </ButtonNext>
          </>
        )}
      </CarouselProvider>
    </div>
  );
};

HomepageRolloverBody.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  editPreview: PropTypes.bool,
};

export default HomepageRolloverBody;
